import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'printSort'
})
export class PrintSortPipe implements PipeTransform {

  transform(value: any, args?: any): any {
  	return value.sort( function(type1, type2){
  		if ( type1.type < type2.type ){
	    	return -1;
	    }else if( type1.type > type2.type ){
	        return 1;
	    }else{
	    	return 0;	
	    }
  	})
  }

}



// WEBPACK FOOTER //
// ./src/app/print-sort.pipe.ts